import { useCallback } from 'react';

import { isDefined } from 'utils/tsHelpers';
import { insertInArray } from 'utils/helpers';
import { useConditionState } from './useConditionState';
import { useRequirementConditionsState } from '../requirement';
import { createBlankCondition } from '../../utils';
import { useQueryStateContext } from '../../contexts';
import { useCurrentConditionIndex } from './useCurrentConditionIndex';

export const useDuplicateCondition = () => {
  const { condition } = useConditionState();
  const { setConditions } = useRequirementConditionsState();
  const { setToLatestId } = useQueryStateContext();
  const index = useCurrentConditionIndex();

  return useCallback(() => {
    if (isDefined(condition)) {
      const { id, dataType, ...conditionProps } = condition;
      const newCondition = createBlankCondition(dataType, conditionProps);
      setConditions((conditions) => {
        if (!isDefined(index)) {
          return [...conditions, newCondition];
        }
        return insertInArray([...conditions], index + 1, newCondition);
      });
      setToLatestId(newCondition.id);
    }
  }, [setConditions, JSON.stringify(condition), setToLatestId]);
};
